import Input from "./Input";

export default class Radios extends Input {

    /**
     * @type {HTMLElement[]}
     */
    inputElements = [];

    constructor(element, form) {
        super(element, form);
        this.inputElements = Array.from(this.element.querySelectorAll('input'));

        if (!this.inputElements.length) {
            return;
        }
        
        this._value = this.inputElements.find(el => el.checked)?.value;

        if (this.inputElements[0].required) {
            this.validations.push('required');
        }

        this.name = this.inputElements[0].name;

        this.addListeners();
    }

    addListeners() {
        this.inputElements.forEach(radio => {
            radio.addEventListener('change', () => {
                this.value = this.inputElements.find(el => el.checked)?.value;
            });
        });
    }

    reset() {
        this.inputElements.forEach((el, i) => {
            el.checked = i === 0 ? true : false;
        });
        this.value = this.inputElements.find(el => el.checked)?.value;
        this.removeError();
    }
}
